module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?> <svg width=21px height=18px viewBox=\"0 0 21 18\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <polygon fill-rule=nonzero points=\"0.01 18 21 9 0.01 0 0 7 15 9 0 11\"></polygon> </svg>";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/send.svg
// module id = 278
// module chunks = 0